/**
 * Форматує ціну для кращої читабельності
 * 
 * @param {number|string} price - Ціна для форматування
 * @returns {string} Відформатована ціна з розділювачами тисяч
 * 
 * @example
 * formatPrice(79281.243) // "79 281.24"
 * formatPrice(1500) // "1 500"
 * formatPrice(99.5) // "99.50"
 */
export const formatPrice = (price) => {
    if (price === null || price === undefined) return '';
    
    const numPrice = typeof price === 'string' ? parseFloat(price) : price;
    
    if (isNaN(numPrice)) return '';
    
    // Форматуємо з українською локаллю (пробіл як розділювач тисяч)
    // Максимум 2 знаки після коми, мінімум 0 (щоб не додавати .00 до цілих чисел)
    return numPrice.toLocaleString('uk-UA', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
};

export default formatPrice;

